// © Microsoft Corporation. All rights reserved.

import { TelemetryActionType, TelemetryBehaviorType, TelemetryContentType, TelemetryObjectBase } from "@msnews/telemetry-contracts";
import { TelemetryEventNames, dispatchTelemetryEvent } from "@msnews/social-utils";

export interface FollowButtonTelemetryObjects {
    followButton: TelemetryObjectBase;
}

export const followButtonTelemetryContracts = {
    followButton: {
        name: "FollowButton",
        content: {
            type: TelemetryContentType.Profile
        }
    }
};

export const followButtonTelemetryActionDispatchers = {
    followButton: (element: any, isFollow: boolean, telemetryObject: TelemetryObjectBase): void => {
        const telemetryEventDispatcherInfo = {
            eventName: TelemetryEventNames.genericAction,
            contract: telemetryObject.contract,
            subTypes: {action: TelemetryActionType.Click, behavior: isFollow ? TelemetryBehaviorType.Follow : TelemetryBehaviorType.Unfollow}
        };

        dispatchTelemetryEvent(telemetryEventDispatcherInfo, element, null);
    }
};